import { z } from 'zod';
import { helperSchema, optionalizeString } from '../../zodExtensions.js';
import { Pegasus } from './pegasus.js';
export const CustomFieldValueType = {
    Text: 'Text',
    Number: 'Number',
    Date: 'Date',
    Select: 'Select',
    MultiSelect: 'MultiSelect',
};
export const customFieldReferenceImages = z
    .array(z.object({
    url: z.url(),
    caption: optionalizeString(z.string().max(150, {
        message: 'Caption must be 150 characters or less',
    })),
}))
    .max(4, { message: 'A custom field can have at most 4 reference images' });
export const customField = z.object({
    id: z.number(),
    displayName: z.string().max(30, {
        message: 'Name must be less than 30 characters',
    }),
    description: z.string(),
    options: helperSchema.csv.optional(),
    referenceImages: customFieldReferenceImages.optional(),
    createdOn: z.string().optional(),
    valueType: z.union([
        z.literal(`${CustomFieldValueType.Text}`),
        z.literal(`${CustomFieldValueType.Number}`),
        z.literal(`${CustomFieldValueType.Date}`),
        z.literal(`${CustomFieldValueType.Select}`),
        z.literal(`${CustomFieldValueType.MultiSelect}`),
    ]),
});
export const customFieldCreate = customField.omit({ id: true });
export const customFieldUpdate = customField.omit({ valueType: true });
// ------- customer ui custom field schemas -------
export const customUiCustomFieldSelect = customField
    .pick({
    id: true,
    description: true,
    displayName: true,
    referenceImages: true,
})
    .merge(z.object({
    required: z.boolean(),
    valueType: z.union([
        z.literal(`${CustomFieldValueType.Select}`),
        z.literal(`${CustomFieldValueType.MultiSelect}`),
    ]),
    options: z.string().array(),
}));
export const customUiCustomField = customField
    .pick({
    id: true,
    displayName: true,
    description: true,
    referenceImages: true,
})
    .merge(z.object({
    required: z.boolean(),
    valueType: z.union([
        z.literal(`${CustomFieldValueType.Text}`),
        z.literal(`${CustomFieldValueType.Number}`),
        z.literal(`${CustomFieldValueType.Date}`),
    ]),
}));
export const customFieldUiCollection = z.array(z.union([customUiCustomField, customUiCustomFieldSelect]));
export const customerUiEventCollectCustomFieldsParams = z.object({
    isDefaultCommentFieldRequired: z.boolean().optional(),
    showDefaultCommentField: z.boolean(),
    isMediaUploadRequired: z.boolean(),
    mediaUploadInstructions: z.string().optional(),
    minimumMediaUploadAmount: z.number().optional(),
    allowedContentTypes: Pegasus.eventCollectCustomFieldsParams.shape.allowedContentTypes,
    customFields: customFieldUiCollection,
});
export const customerUiEventCustomField = z.object({
    type: z.literal('collectCustomFields'),
    params: customerUiEventCollectCustomFieldsParams,
});
// ---- applied custom field schemas, these represent the custom field values ----
export const appliedCustomField = customField
    .omit({ options: true, referenceImages: true })
    .merge(z.object({ value: z.string() }));
export const appliedCustomFieldCreate = appliedCustomField.pick({
    id: true,
    value: true,
});
//# sourceMappingURL=customField.js.map